export default __webpack_public_path__ + "static/media/yo9.1e485deb.png";